import { Component, Prop, Vue } from 'vue-property-decorator'

import BadgePerson from '@/components/BadgePerson/index.vue'
import BadgeCosts from '@/components/BadgeCosts/index.vue'

import tableHelper from '@/helpers/table'

import { bus } from '@/main'

import { library } from '@fortawesome/fontawesome-svg-core'

import {
	faClock,
	faScroll,
	faFeatherPointed,
	faPrint,
	faBook,
	faTriangleExclamation,
	faPenFancy,
	faPenToSquare,
} from '@fortawesome/free-solid-svg-icons'

library.add(
	faClock,
	faScroll,
	faFeatherPointed,
	faPrint,
	faBook,
	faTriangleExclamation,
	faPenToSquare,
)

@Component({
	components: {
		BadgePerson,
		BadgeCosts,
	},
})
export default class CardDeadline extends Vue {
	@Prop({ required: true }) readonly deadline

	get selectedDeadlineType() {
		return this.$store.state.deadlines.selectedDeadlineType
	}

	getActiveSecondaryNumber() {
		const secNumbers = this.deadline?.trial?.secondaryNumbers

		if (secNumbers?.length) {
			const found = secNumbers.find((secondary) => secondary.active)
			if (found) return `${found.number} - ${found.type}`
		}
		return false
	}

	formatCNJ() {
		const val = this.deadline?.trial?.cnj

		if (val) {
			return tableHelper.formatCNJ(val)
		}

		return ''
	}

	getShortDate(date) {
		if (date && typeof date !== 'string') {
			date = date.toISOString()
		}

		let result = date?.split('T')[0]
		result = result?.split('-')?.reverse()

		if (result && result.pop) {
			result.pop()
			return result.join('/')
		}

		return null
	}

	getClientReview() {
		return this.deadline?.trial?.groups?.[0]?.group?.client_review
	}

	getGroupAndClient(deadline) {
		let group = deadline?.trial?.groups

		if (!group || !group.length) {
			group = deadline?.trial?.group
		}

		group = group?.[0]

		if (group && group?.group) {
			group = group.group

			const clients = group?.clients
			let client

			if (clients && clients.length) client = clients?.[0]

			return `(${group.name}) ${client?.name || ''}`
		}

		return ''
	}

	onClick(deadlineId) {
		bus.$emit('open-modal-deadline', deadlineId)
	}

	getCheck(revision) {
		if (this.deadline) {
			if (revision === 'elaboration') {
				if (
					this.deadline.status === 'Em 1ª Revisão' ||
					this.deadline.status === 'Em 2ª Revisão' ||
					this.deadline.status === 'Aguardando protocolo' ||
					this.deadline.status === 'Protocolado' ||
					this.deadline.status === 'Desinteresse'
				) {
					return true
				}

				return false
			}

			if (revision === 'first') {
				if (
					this.deadline.status === 'Em 2ª Revisão' ||
					this.deadline.status === 'Aguardando protocolo' ||
					this.deadline.status === 'Protocolado' ||
					this.deadline.status === 'Desinteresse'
				) {
					return true
				}

				return false
			}

			if (revision === 'second') {
				if (
					this.deadline.status === 'Aguardando protocolo' ||
					this.deadline.status === 'Protocolado' ||
					this.deadline.status === 'Desinteresse'
				) {
					return true
				}

				return false
			}
		}

		return false
	}

	getTooltip(revision) {
		if (this.deadline) {
			if (revision === 'first') {
				return `Revisor: ${this.deadline.reviewerFirst.name}`
			}

			if (revision === 'second') {
				return `Rev. Final: ${this.deadline.reviewerFinal.name}`
			}
		}
	}

	getCostsStatusClass(costsStatus) {
		let htmlClass = ''

		switch (costsStatus) {
			case 'Gerar custas':
			case 'Verificar com o responsável':
				htmlClass = 'red'
				break
			case 'Custas geradas':
				htmlClass = 'orange'
				break

			case 'Custas enviadas':
			case 'Pagamento interno':
				htmlClass = 'yellow'
				break

			case 'Após a distribuição':
			case 'Não há':
			case 'Pagas':
				htmlClass = 'green'
				break
		}

		return htmlClass
	}

	isTwoDaysBefore(date) {
		const now = new Date()
		const differenceInMs = now.getTime() - new Date(date).getTime()

		const differenceInDays = differenceInMs / 1000 / 60 / 60 / 24

		return differenceInDays > -2
	}

	getClass() {
		switch (this.deadline.status) {
			case 'Arquivado':
			case 'Desinteresse':
				return 'alert-secondary'
			case 'Protocolado':
				return 'alert-success'
		}

		const nowString = new Date()?.toISOString()?.split('T')?.[0]

		const midDayUtcString = 'T12:00:00.000Z'
		const today = new Date(nowString + midDayUtcString)
		const realFatalDate = new Date(
			this.deadline.realFatalDate + midDayUtcString,
		)

		const oneDayInMs = 24 * 60 * 60 * 1000

		const todayWeekDayName = getWeekDayName(today)
		let diffDays = oneDayInMs * 2 // dois dias

		if (today.getTime() >= realFatalDate.getTime()) {
			return 'alert-danger'
		}

		if (
			todayWeekDayName === 'Sexta-feira' ||
			todayWeekDayName === 'Quinta-feira'
		) {
			// soma os dois dias do fds
			diffDays = diffDays + oneDayInMs * 2
		}

		if (today.getTime() + diffDays >= realFatalDate.getTime()) {
			return 'alert-warning'
		}

		return 'alert-info'
	}
}

function getWeekDayName(date) {
	const weekDayNames = [
		'Domingo',
		'Segunda-feira',
		'Terça-feira',
		'Quarta-feira',
		'Quinta-feira',
		'Sexta-feira',
		'Sábado',
	]
	const weekDayNumber = date.getDay()
	return weekDayNames[weekDayNumber]
}
